module.exports = __webpack_public_path__ + "img/circle_tick.485856c1.svg";